<dx-popup [dragEnabled]="false" [height]="'90vh'" [fullScreen]="appService.isSmallScreen()" [showTitle]="true"
  [hideOnOutsideClick]="false" [(visible)]="popupVisible" [width]="860" contentTemplate="popupContent"
  [wrapperAttr]="{ class: 'weekly-selector-popup' }"
  title="{{'WEEKLY_SELECTOR.TITLE' | translate}}">
  <dxi-toolbar-item [visible]="editMode" location="after" toolbar="bottom" widget="dxButton">
    <dxo-options [icon]="'save'" [onClick]="onSaveClick" [stylingMode]="'contained'" [type]="'default'"
      [text]="'BUTTONS.SAVE' | translate"></dxo-options>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="before" toolbar="bottom">
    <div class="timezone">
      <span class="material-symbols-outlined">public</span>
      <span>{{ timezone }}</span>
    </div>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after" toolbar="bottom" widget="dxButton">
    <dxo-options [icon]="'close'" [onClick]="onCancelClick" [stylingMode]="'outlined'"
      [text]="(editMode ? 'BUTTONS.CANCEL' : 'BUTTONS.CLOSE') | translate"></dxo-options>
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'popupContent'" class="popup-content">
    <dx-scroll-view>
      <app-week-grid [editMode]="editMode" [value]="draft"></app-week-grid>
    </dx-scroll-view>
  </div>
</dx-popup>
